<template>
  <div>
    <el-table
      :data="visibleData"
      tooltip-effect="light"
      :style="style"
      :height="height"
      :border="border"
      row-class-name="table-row-class-name"
      :header-row-style="{
        background: 'transparent',
      }"
    >
      <el-table-column
        v-for="col in columns"
        :key="col.prop"
        :prop="col.prop"
        :type="col.type"
        :width="col.width"
        :label="col.label"
        :fixed="col.fixed"
        header-align="center"
        align="center"
      >
        <template slot="header">
          <column-header :label="col.label" :unit="col.unit" />
        </template>
        <template slot-scope="scope">
          <column-content :scope="scope" :col="col" />
        </template>
      </el-table-column>
      <el-table-column
        v-if="actions"
        label="操作"
        align="center"
        :width="colWidth"
        class="col-control"
      >
        <template slot-scope="scope">
          <div v-for="(btn, i) in actions" :key="i" class="control">
            <el-button
              :size="btn.size || 'mini'"
              :type="btn.type"
              :plain="btn.plain"
              @click="btn.onClick(scope.$index, scope.row)"
              v-if="btn.style === 'btn'"
              :disabled="btn.disable && btn.disable(scope.row)"
              >{{ btn.label }}</el-button
            >
            <a
              v-if="btn.style === 'link' && scope.row.path"
              target="_blank"
              :href="btn.href(scope.$index, scope.row)"
              >{{ btn.label }}</a
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="sizes"
        :page-size="size"
        :current-page="page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    ColumnContent: {
      props: {
        scope: {
          required: true
        },
        col: {
          required: true
        }
      },
      render(h) {
        const parent = this.$parent;
        const { scope, col } = this;
        return col.render ? (
          col.render.call(parent._renderProxy, h, scope)
        ) : (
          <span>{scope.row[col.prop]}</span>
        );
      }
    },
    ColumnHeader: {
      props: {
        label: {
          required: true
        },
        unit: {
          required: true
        }
      },
      render() {
        // const parent = this.$parent;
        const { label, unit } = this;

        if (unit) {
          return (
            <div>
              <div>{label}</div>
              <div>{unit}</div>
            </div>
          );
        } else {
          return <span>{label}</span>;
        }
      }
    }
  },
  props: {
    columns: Array,
    actions: Array,
    pageSizes: Array,
    pageSize: Number,
    async: Boolean,
    data: Array,
    loader: Function,
    border: {
      type: Boolean,
      default: false
    },
    height: String,
    colWidth: {
      type: String,
      default: '180px'
    },
    style: {
      type: Object,
      default: function() {
        return { width: '100%' };
      }
    }
  },
  data() {
    return {
      sizes: this.pageSizes || [10, 20, 50, 100],
      size: this.pageSize || 20,
      page: 1,
      total: this.async ? 0 : this.data.length,
      listData: this.data || [],
      loading: false
    };
  },
  computed: {
    visibleData() {
      if (this.async) return this.listData;
      const start = this.size * (this.page - 1);
      return this.listData.slice(start, start + this.size);
    }
  },
  mounted() {
    this.update();
  },
  watch: {
    data(val) {
      this.listData = val || [];
      if (!this.async) this.total = val ? val.length : 0;
    },
    type: function() {
      this.update();
    },
    page: function() {
      this.update();
    },
    size: function() {
      this.page = 1;
      this.update();
    }
  },
  methods: {
    handleSizeChange(val) {
      this.size = val;
    },
    handleCurrentChange(val) {
      this.page = val;
    },
    async update({ page } = {}) {
      if (!this.async) return;
      this.loading = true;
      if (!isNaN(+page)) {
        this.page = page;
      }
      const res = await this.loader({
        page: this.page,
        size: this.size
      });
      this.total = res.total;
      this.listData = res.data;
      this.loading = false;
    },
    async load(data) {
      await this.update(data);
    },
    tableRowClassName({ row, rowIndex }) {
      console.log(row);
      if (rowIndex % 2 !== 0) {
        return 'custom-table-row-odd';
      } else {
        return 'custom-table-row-even';
      }
    }
  }
};
</script>
<style lang="less" scoped>
.control {
  display: inline-block;
  margin-right: 10px;

  a {
    color: #e6a23c;
  }
}
div /deep/ .el-pager li {
  padding: 0 0px;
    font-size: 13px;
    min-width: 30.5px;
    height: 28px;
    line-height: 28px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center;
    border: 1px solid #fff;
    background-color: #081a29;
    color: #fff;
}
div /deep/.el-pager li.active {
    color: #078ef6 !important;
    cursor: default;
}
</style>
